import { v4 as uuidv4 } from 'uuid'

import { RIGHT_STATUS } from '../../../../../../constants/rights'
import {
  AGE_RANGE_18_24,
  AGE_RANGE_25_34,
  AGE_RANGE_35_44,
  AGE_RANGE_45_54,
  AGE_RANGE_55_64,
  AGE_RANGE_65_PLUS
} from '../../../../../../constants/ageRanges'
import {
  NAME,
  STATUS,
  RIGHT_TYPE,
  RIGHT_TYPE_DIGITAL,
  DIGITAL_ALLOCATION_TYPE,
  DIGITAL_ALLOCATION_TYPE_BUDGET,
  ALLOCATION,
  ALLOCATION_UNIT,
  DELIVERED,
  ACTION,
  GENDER,
  GENDER_MALE,
  GENDER_FEMALE,
  AGE,
  BUDGET,
  BID_CAP,
  BRAND_KEYWORDS,
  RIGHT_TYPE_POSTS,
  REQUEST_CREATIVE_ASSETS,
  REQUEST_LOGO,
  CREATIVE_ASSETS_DATE,
  LOGO_DATE,
  CAMPAIGNS,
  SOCIAL_MEDIA_POST,
  INCLUDE_LINKED_INSTAGRAM_ACCOUNT
} from '../../fields'
import { START_DATE, END_DATE } from '../../../../../ReusableFormFields/StartEndDateRangeFields/fields'
import {
  ALLOCATION_TYPE,
  INVENTORY_TYPE,
  INVENTORY_TYPE_AD_PLACEMENTS,
  IS_SUB_ALLOCATION,
  AD_PLACEMENTS,
  AD_UNITS,
  ADVANCED_SETTINGS,
  SKIPPABLE_ADS_ENABLED,
  AD_INVENTORY_TARGETING_ENABLED,
  CUSTOM_TARGETING_ENABLED,
  BILLING_EVENT,
  allocationTypes,
  GEO_TARGETING_ENABLED,
  DEVICE_TARGETING_ENABLED
} from './sectionsLists/OnsiteRightCreateSections/fields'

export const rightGenderInitialValues = {
  [GENDER]: {
    [GENDER_MALE]: true,
    [GENDER_FEMALE]: true
  }
}

export const rightAgeInitialValues = {
  [AGE]: {
    [AGE_RANGE_18_24]: true,
    [AGE_RANGE_25_34]: true,
    [AGE_RANGE_35_44]: true,
    [AGE_RANGE_45_54]: true,
    [AGE_RANGE_55_64]: true,
    [AGE_RANGE_65_PLUS]: true
  }
}

export const getInitialValues = ({ isDigitalRightTypeAllowed, facebookIsConnected, isGamAccountConnected }) => ({
  [NAME]: '',
  [STATUS]: RIGHT_STATUS.LIVE,
  [START_DATE]: '',
  [END_DATE]: '',
  [ALLOCATION]: '',
  [ALLOCATION_UNIT]: '',
  [DELIVERED]: '',
  [ACTION]: '',
  [DIGITAL_ALLOCATION_TYPE]: DIGITAL_ALLOCATION_TYPE_BUDGET,
  [RIGHT_TYPE]: isDigitalRightTypeAllowed ? RIGHT_TYPE_DIGITAL : RIGHT_TYPE_POSTS,
  [BUDGET]: '',
  [BID_CAP]: '',
  [BRAND_KEYWORDS]: [{ text: '', id: uuidv4() }],
  [REQUEST_CREATIVE_ASSETS]: false,
  [CREATIVE_ASSETS_DATE]: '',
  [REQUEST_LOGO]: false,
  [LOGO_DATE]: '',
  [CAMPAIGNS]: [{ text: '', id: uuidv4() }],
  [SOCIAL_MEDIA_POST]: '',
  [INCLUDE_LINKED_INSTAGRAM_ACCOUNT]: facebookIsConnected,
  ...(isGamAccountConnected && {
    [ALLOCATION_TYPE]: allocationTypes.viewable_impressions,
    [IS_SUB_ALLOCATION]: false,
    [INVENTORY_TYPE]: INVENTORY_TYPE_AD_PLACEMENTS,
    [AD_PLACEMENTS]: [],
    [AD_UNITS]: [],
    [ADVANCED_SETTINGS]: {
      [SKIPPABLE_ADS_ENABLED]: false,
      [AD_INVENTORY_TARGETING_ENABLED]: false,
      [GEO_TARGETING_ENABLED]: true,
      [DEVICE_TARGETING_ENABLED]: true,
      [CUSTOM_TARGETING_ENABLED]: false
    },
    [BILLING_EVENT]: allocationTypes.viewable_impressions
  })
})
